import React, { useState,useEffect, useRef, useMemo } from 'react';
import {
  InputAdornment,
  Grid,
  Box,
  Autocomplete,
  Button,
  TextField,
  Typography,
  TableCell,
  TableRow,
  TableBody,
  Table,
  TableHead,
  TableContainer,TablePagination,Toolbar,OutlinedInput,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableSortLabel,
  createFilterOptions
} from '@mui/material';
import PropTypes from 'prop-types';
import Scrollbar from 'src/components/Scrollbar';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { YearCalendar } from '@mui/x-date-pickers/YearCalendar';
import { Select, MenuItem } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { Page, Text, View, Document, StyleSheet, Image,pdf,PDFDownloadLink,PDFViewer,Font, Rect, Svg,Line } from '@react-pdf/renderer';
import { monthlyClientDashboard, getLatestStatus, getCameraTrack, getCameras } from 'src/api/reports';
import html2canvas from 'html2canvas';
import FormComponent from 'src/templates/MonthlyClientTemplate';
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import HistoryIcon from '@mui/icons-material/History';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import CountBoard from 'src/components/CountBoard';
// import { Timeline } from '@mui/icons-material';
import { Timeline,TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineSeparator } from '@mui/lab';
import Drawer from '@mui/material/Drawer';
import CloseIcon from '@mui/icons-material/Close';
import Divider from '@mui/material/Divider';
import { getClientProperties } from 'src/api/ShiftMaster';
import { getClientGroupInfo } from 'src/api/liveCameras';



const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const months = [
    { name: 'January', value: '1' },
    { name: 'February', value: '2' },
    { name: 'March', value: '3' },
    { name: 'April', value: '4' },
    { name: 'May', value: '5' },
    { name: 'June', value: '6' },
    { name: 'July', value: '7' },
    { name: 'August', value: '8' },
    { name: 'September', value: '9' },
    { name: 'October', value: '10' },
    { name: 'November', value: '11' },
    { name: 'December', value: '12' }
  ];

  const currentYear = new Date().getFullYear();
  
  const years = //[currentYear - 1,currentYear,currentYear + 1];
  [
    { name:(currentYear - 1).toString(),value:currentYear - 1 },
    { name:(currentYear).toString(),value:currentYear },
    { name:(currentYear + 1).toString(),value:currentYear + 1 }
  ]


const CameraActiveReport = ({clientList,camerasList}) => {
  const theme = useTheme();
  const contentRef = useRef();
  

  const [loading, setLoading] = useState(false);

  const [selectedDate, setSelectedDate] = useState(null);

  const [openAutoClient, setOpenAutoClient] = useState(false);
  const [openAutoLocation, setOpenAutoLocation] = useState(false);
  const [openAutoGroup, setOpenAutoGroup] = useState(false);
  const [openAutoCam, setOpenAutoCam] = useState(false);

  const [filterName, setFilterName] = useState(''); 
  
  const [selectAllLocation, setSelectAllLocation] = useState(false);
  const [selectAllCam, setSelectAllCam] = useState(false);

  const [value1, setValue1] = useState(null);
  const [value2, setValue2] = useState(null);
  const [value3, setValue3] = useState(null);
  const [value4, setValue4] = useState(null); // group
      
  const [data, setData] = useState([])
  const [row,rowChange] = useState([])
  const [page,pageChange]=useState(0)
  const [rowPerPage,rowPerPageChange]=useState(5)

  const [loadDocument,setLoadDocument]=useState(false)

  const [showChart,setShowChart]=useState(false)
  const [graphData,setGrapghData]=useState([])
  const [noData,setNoData] = useState(false)
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedCameras,setSelectedCameras] = useState([])
  const [cameras,setCameras] = useState([])
  const [locations, setLocations] = useState([]);
  const [groups,setGroups]=useState([])
  const [clientGroupInfo, setClientGroupInfo] = useState([]);

  const [response,setResponse] = useState([])
  
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [track, setTrack] = useState({ active_times: [], inactive_times: [] });
  const [historyCameraName, setHistoryCameraName] = useState("");
  

  const [isDateSelected, setIsDateSelected] = useState(false);

  const [offlineDialogOpen, setOfflineDialogOpen] = useState(false);
  const [offlineCameras, setOfflineCameras] = useState([]);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  //  const handleOfflineCountClick = () => {
  //   const offlineCams = response.filter(camera => {
  //     const status = getCameraStatus(camera);
  //     return status === 'inactive';
  //   });
    
  //   setOfflineCameras(offlineCams);
  //   setOfflineDialogOpen(true);
  // };

  const handleOfflineCountClick = () => {
  // let offlineCams = [];

  // // If response has data (after Generate), use it
  // if (response.length > 0) {
  //   offlineCams = response.filter(camera => getCameraStatus(camera) === 'inactive');
  // } 
  // // Otherwise, use the data from page load
  // else if (offlineCameras.length > 0) {
  //   offlineCams = offlineCameras;
  // }

  setOfflineCameras(offlineCameras);
  setOfflineDialogOpen(true);
};

  

  useEffect(() => {
  // if (camerasList.length > 0) {
  //   const today = dayjs().format('YYYY-MM-DD');
  //   const allCameraIds = camerasList.map(cam => cam.deviceid).join(",");

  //   let body = {
  //     camera_id: allCameraIds,
  //     date: today
  //   };

  //   setLoading(true);
  //   getLatestStatus(body, (response) => {
  //     setLoading(false);
  //     if (response.status === 200 && response.data.length > 0) {
  //       //setResponse(response.data);
  //       const offlineCams = response.data.filter(cam => getCameraStatus(cam) === "inactive");
  //       setOfflineCameras(offlineCams);
  //       setInActive(offlineCams.length); // Show inactive count in CountBoard
  //     } else {
  //       //setResponse([]);
  //       setOfflineCameras([]);
  //       setInActive(0);
  //     }
  //   });
  // }
  
  //setLoading(true);
  getCameras((response)=>{
        if(response.data!==null || response.data!==''){
          console.log(response.data)
          const filteredCameras = response.data.filter(
          (camera) => camera.CameraActiveStatus === 0 && camera.IsAgentBased === 1);
          console.log(filteredCameras);
          setOfflineCameras(filteredCameras);
          setInActive(filteredCameras.length)
        }
  })
}, []);


  const getCameraClientId = (camera) =>
    Number(camera?.clientid ?? camera?.client_id ?? camera?.ClientId ?? 0);

  const getCameraLocationId = (camera) =>
    Number(
      camera?.clientid ??
      0
    );

  useEffect(() => {
    
    if (!value3?.ID) {
      setCameras([]);
      return;
    }

    if (groups.length > 0) {
      if (!value4?.Id) {
        setCameras([]);
        return;
      }

      const groupedCameras = (clientGroupInfo || []).filter(
        (item) => Number(item.GroupId) === Number(value4.Id)
      );
      setCameras(groupedCameras);
      return;
    }

    const sourceCameras = camerasList || [];

    if (locations.length > 0) {
      const selectedLocationIds = (selectedLocations || []).map((id) => Number(id));
      if (selectedLocationIds.length === 0) {
        setCameras([]);
        return;
      }

      setCameras(
        sourceCameras.filter((camera) =>
          selectedLocationIds.includes(getCameraLocationId(camera))
        )
      );
      return;
    }

    setCameras(
      sourceCameras.filter((camera) => getCameraClientId(camera) === Number(value3.ID))
    );
  }, [value3, value4, groups, clientGroupInfo, camerasList, locations, selectedLocations]);

  const isValidTime = (time) => {
    return time && time !== null && time !== undefined && time.trim() !== "";
  };

  // helper function to determine camera status
   const getCameraStatus = (camera) => {
    const hasActiveTime = isValidTime(camera.LastActiveTime);
    const hasInactiveTime = isValidTime(camera.LastInactiveTime);

    if (hasActiveTime && !hasInactiveTime) {
      return 'active';
    }
    if (hasInactiveTime && !hasActiveTime) {
      return 'inactive';
    }
    if (hasActiveTime && hasInactiveTime) {
      const activeTime = new Date(camera.LastActiveTime);
      const inactiveTime = new Date(camera.LastInactiveTime);
      return activeTime > inactiveTime ? 'active' : 'inactive';
    }
    return 'inactive'; // Default to inactive if no times available
  };

  const handleButtonClick = () => {
    setOrder('asc')
    setOrderBy('')
    setError(false);
    setIsDateSelected(false);
    setIsClientSelected(false);
    // setIsCameraSelected(false)
    setLoading(true);
    setResponse([]); 
    setNoData(false); 

    //setInActive(0)

    let activeCount = 0;
    let inactiveCount = 0;


    let isValid  = true;
    
    console.log(value3)
    console.log(selectedCameras)
    console.log(selectedDate)
  const cameraId = selectedCameras.map(val=>val.deviceid).join(",")
    if(!value3){
      setError(true)
      setIsClientSelected(true)
      isValid = false
    }

    if(selectedCameras.length===0){
      setError(true)
      //setIsCameraSelected(true)
      isValid = false
    }

    if(!selectedDate){
      setError(true)
      setIsDateSelected(true)
      isValid = false
    }



    if(isValid){
      
      const cameraId = selectedCameras.map(val=>val.deviceid).join(",")
      const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
      let body={
        camera_id:cameraId,
        date : formattedDate
      }

      getLatestStatus(body,(response)=>{
        setLoading(false);
        if(response.status===200){
          if(response.data.length>0){
            setResponse(response.data)
            // response.data.forEach(camera => {
            //   const status = getCameraStatus(camera);
            //   if (status === 'active') {
            //     activeCount++;
            //   } else {
            //     inactiveCount++;
            //   }
            // });
        
           
            // setInActive(inactiveCount);
          
          }
          else {
          setNoData(true); 
        }
        }
        else {
          setNoData(true); 
        }
      })

      // monthlyClientDashboard(body,(response)=>{
      //    if(response.status===200){
      //       if(response.data.length>0){
              
      //         // console.log(response.data)
      //         setData(response.data)
      //         let barGraphData = response.data[0].camera_wise_counts
      //         setGrapghData(barGraphData)
      //         setShowChart(true)
      //       }
      //      else{
      //       setData([])
      //        // setShowChart(false)
      //        setNoData(true)
      //      }
      //    }
      // })
      
    }  
    else{
      setLoading(false);
    } 
  };

// useEffect(() => {
//     setData(values)
// }, [])

const handleChangePage = (event,newpage)=>{
    if(newpage===0){
        pageChange(0);
    }
    else{
        pageChange(newpage)
    }
}

const handleRowsPerPage = (e)=>{
    rowPerPageChange(e.target.value)
    pageChange(0)
}

const handleFilterByName = (event) => {
    const pattern=event.target.value.trim()
    setFilterName(pattern);
  };

  useEffect(()=>{
    // console.log(filterName)
  },[filterName])

  const convertImageToBase64 = (file, callback) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      callback(reader.result);
    };
    reader.readAsDataURL(file);
  };


 const [pieChartData,setPieChartData]=useState([])

  const [error,setError]=useState(false)
  const [isMonthSelected,setIsMonthSelected]=useState(false)
  const [isYearSelected,setIsYearSelected]=useState(false)
  const [isClientSelected,setIsClientSelected]=useState(false)
  const [isCameraSelected,setIsCameraSelected] = useState(false)
  const [deviceStats,setDeviceStats] = useState([]);
 // const [active,setActive] = useState(0)
  const [inactive,setInActive] = useState(0)

   const [minSelectableDate, setMinSelectableDate] = useState(null);
  const [maxSelectableDate, setMaxSelectableDate] = useState(null);

   // Function to handle date selection
  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    setIsDateSelected(false);
    setError(false);
    
    // if (newDate) {
    //   // Set the selectable range to 30 days before the selected date
    //   const minDate = dayjs(newDate).subtract(30, 'day');
    //   const maxDate = dayjs(newDate);
      
    //   setMinSelectableDate(minDate);
    //   setMaxSelectableDate(maxDate);
    // } else {
    //   setMinSelectableDate(null);
    //   setMaxSelectableDate(null);
    // }
  };

  // Function to disable dates outside the 30-day range
  const shouldDisableDate = (date) => {
    if (!minSelectableDate || !maxSelectableDate) return false;
    return date.isBefore(minSelectableDate, 'day') || date.isAfter(maxSelectableDate, 'day');
  };



  const normalizeDisplayName = (name) =>
    String(name || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

  const buildUniqueClientOptions = (clients) => {
    const grouped = new Map();

    (clients || []).forEach((client) => {
      const key = normalizeDisplayName(client?.displayname);
      if (!key) return;

      if (!grouped.has(key)) {
        grouped.set(key, []);
      }
      grouped.get(key).push(client);
    });

    return Array.from(grouped.values()).map((groupItems) => {
      if (groupItems.length === 1) return groupItems[0];

      const assignTargets = new Set(
        groupItems
          .map((item) => Number(item.AssignClient || 0))
          .filter((assignId) => assignId > 0)
      );

      const mappedMain = groupItems.find((item) => assignTargets.has(Number(item.ID)));
      if (mappedMain) return mappedMain;

      const rootEntry = groupItems.find((item) => Number(item.AssignClient || 0) === 0);
      return rootEntry || groupItems[0];
    });
  };

  const uniqueClientOptions = useMemo(
    () => buildUniqueClientOptions(clientList || []),
    [clientList]
  );

  const selectedLocationOptions = useMemo(
    () => locations.filter((loc) => selectedLocations.includes(loc.ID || loc.id)),
    [locations, selectedLocations]
  );
  const showLocationDropdown = Boolean(value3 && locations.length > 0);
  const showGroupDropdown = groups.length >= 1;
  const compactLayout = showLocationDropdown && showGroupDropdown;

  const formatLocations = (locationValue) => {
    if (Array.isArray(locationValue)) {
      return locationValue
        .map((val) => String(val || '').trim())
        .filter(Boolean);
    }

    if (typeof locationValue === 'string') {
      return locationValue
        .split(',')
        .map((val) => val.trim())
        .filter(Boolean);
    }

    return [];
  };

  const loadGroupsByClientOrLocations = (clientId, locationIds = []) => {
    
    const body = {
      clientId: locationIds.length > 0 ? locationIds.join(',') : clientId,
      groupId: 0,
    };

    getClientGroupInfo(body, (response) => {
      if (response.status === 200 && response.data.length > 0) {
        setClientGroupInfo(response.data);
        const uniqueGroups = Array.from(
          new Map(
            response.data.map((item) => [item.GroupId, { Id: item.GroupId, GroupName: item.GroupName }])
          ).values()
        );
        setGroups(uniqueGroups);
      } else {
        setClientGroupInfo([]);
        setGroups([]);
        setValue4(null);
      }
    });
  };

  const handleClientChange = (_, newValue) => {
    setValue3(newValue);
    setIsClientSelected(false);
    setValue4(null);
    setValue1(null);
    setValue2(null);
    setGroups([]);
    setClientGroupInfo([]);
    setLocations([]);
    setSelectedLocations([]);
    setSelectAllLocation(false);
    setSelectedCameras([]);
    setSelectAllCam(false);
    setSelectedDate(null);
    setIsDateSelected(false);
    setResponse([]);
    setData([]);
    setGrapghData([]);
    setNoData(false);
    setError(false);
    setOpenAutoLocation(false);
    setOpenAutoGroup(false);
    setOpenAutoCam(false);

    if (!newValue) {
      setCameras([]);
      return;
    }

    getClientProperties({ AssignClient: String(newValue.ID) }, (response) => {
      if (response.status === 200) {
        const normalizedLocations = Array.from(
          new Map(
            (Array.isArray(response.data) ? response.data : response.data ? [response.data] : [])
              .map((location) => ({
                ...location,
                ID: Number(location?.ID ?? location?.id ?? 0),
                Location: String(location?.Location || location?.name || '').trim(),
              }))
              .filter((location) => location.ID > 0)
              .map((location) => [location.ID, location])
          ).values()
        );

        setLocations(normalizedLocations);

        if (normalizedLocations.length > 0) {
          return;
        }
      }

      setLocations([]);
      loadGroupsByClientOrLocations(newValue.ID, []);
    });
  };

  const handleLocationChange = (_, value) => {
    
    if (!value3?.ID) return;

    let nextSelectedLocations = [];
    if (value.some((option) => option.selectall)) {
      nextSelectedLocations = selectAllLocation
        ? []
        : locations.map((location) => location.ID || location.id);
    } else {
      nextSelectedLocations = value.map((location) => location.ID || location.id);
    }

    setSelectedLocations(nextSelectedLocations);
    setSelectAllLocation(locations.length > 0 && nextSelectedLocations.length === locations.length);
    setValue4(null);
    setValue1(null);
    setValue2(null);
    setSelectedCameras([]);
    setSelectAllCam(false);
    setSelectedDate(null);
    setIsDateSelected(false);
    setResponse([]);
    setData([]);
    setGrapghData([]);
    setNoData(false);
    setError(false);
    setOpenAutoGroup(false);
    setOpenAutoCam(false);

    if (locations.length > 0 && nextSelectedLocations.length === 0) {
      setGroups([]);
      setClientGroupInfo([]);
      setCameras([]);
      return;
    }

    loadGroupsByClientOrLocations(value3.ID, nextSelectedLocations);
  };

  useEffect(() => {
    setSelectAllLocation(locations.length > 0 && selectedLocations.length === locations.length);
  }, [locations, selectedLocations]);

  const handleCameraChange = (event, value) => {
    if (value.some(device => device.selectAllCam)) {
      if (selectAllCam) {
        setSelectedCameras([]);
        setSelectAllCam(false);
      } else {
        setSelectedCameras(cameras);
        setSelectAllCam(true);
      }
    } else {
      setSelectedCameras(value);
      setSelectAllCam(value.length === cameras.length);
    }
  };

  useEffect(() => {
    setSelectedCameras((prev) => {
      const availableIds = new Set((cameras || []).map((camera) => Number(camera.deviceid)));
      const filtered = (prev || []).filter((camera) => availableIds.has(Number(camera.deviceid)));
      return filtered;
    });
  }, [cameras]);

  useEffect(() => {
    setSelectAllCam(cameras.length > 0 && selectedCameras.length === cameras.length);
  }, [cameras, selectedCameras]);


  const handleLocationFilterOptions = (options, params) => {
    const filter = createFilterOptions();
    const filtered = filter(options, params);
    return options.length > 0 ? [{ title: 'Select All', selectall: true }, ...filtered] : filtered;
  };

   const handleFilterOptionsCam = (options, params) => {
    const { inputValue } = params;
    const filtered = options.filter(option =>
      String(option.devicename || option.CameraName || '').toLowerCase().includes(inputValue.toLowerCase())
    );
    return options.length > 0 ? [{ displayname: 'Select All', selectAllCam: true }, ...filtered] : filtered;
  };

  const mergedTimeline = [
  ...track.active_times.map(item => ({ ...item, status: "active" })),
  ...track.inactive_times.map(item => ({ ...item, status: "inactive" }))
  ].sort((a, b) => dayjs(a.time).unix() - dayjs(b.time).unix()); 

  const ColorsTimeline = () => {
  return (
    <Timeline position="alternate">
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="secondary" />
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>Secondary</TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="success" />
        </TimelineSeparator>
        <TimelineContent>Success</TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}

  const handleHistoryClick = (id,cameraName) => {
    setHistoryCameraName(cameraName);
    setHistoryOpen(true);      
    setHistoryLoading(true);    
    setTrack({ active_times: [], inactive_times: [] });

    const formattedDate = dayjs(selectedDate).format('YYYY-MM-DD');
    const body = { camera_id: id, date: formattedDate };

    getCameraTrack(body, (response) => {
      setHistoryLoading(false);
      if (response.status === 200 && response.data) {
        
        console.log(response.data)
        setTrack(response.data);
      } else {
        setTrack({ active_times: [], inactive_times: [] });
      }
    });
};


const handleHistoryClose = () => {
  setHistoryOpen(false);
  setHistoryCameraName("");
  setTrack({ active_times: [], inactive_times: [] });
  setHistoryLoading(false);
};


useEffect(() => {
    const today = dayjs();
    const thirtyDaysAgo = today.subtract(29, 'day');
    
    setMinSelectableDate(thirtyDaysAgo);
    setMaxSelectableDate(today);
  }, []);

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const stableSort = (array, comparator) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  };

  const getComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

// const descendingComparator = (a, b, orderBy) => {
//   let aValue = a[orderBy];
//   let bValue = b[orderBy];
  
//   // Handle "N/A" values for datetime fields
//   if (orderBy === 'LastInactiveTime' || orderBy === 'LastActiveTime') {
//     // Convert "N/A" to null for proper comparison
//     aValue = aValue === 'N/A' ? null : aValue;
//     bValue = bValue === 'N/A' ? null : bValue;
    
//     // Handle cases where one or both values are null
//     if (aValue === null && bValue === null) return 0;
//     if (aValue === null) return 1; // N/A values should come last
//     if (bValue === null) return -1; // N/A values should come last
    
//     // Convert to Date objects for proper date comparison
//     aValue = new Date(aValue);
//     bValue = new Date(bValue);
//   }
  
//   // For string fields (ClientName, CameraName)
//   if (typeof aValue === 'string' && typeof bValue === 'string') {
//     return bValue.localeCompare(aValue);
//   }
  
//   // Default comparison for other types
//   if (bValue < aValue) {
//     return -1;
//   }
//   if (bValue > aValue) {
//     return 1;
//   }
//   return 0;
// };
const descendingComparator = (a, b, orderBy) => {
  
  let aValue = a[orderBy];
  let bValue = b[orderBy];
  
  // Handle datetime fields with N/A values
  if (orderBy === 'LastInactiveTime' || orderBy === 'LastActiveTime') {
    // Check for both "N/A" string and null/undefined values
    const aIsNA = aValue === 'N/A' || aValue === null || aValue === undefined || aValue === '';
    const bIsNA = bValue === 'N/A' || bValue === null || bValue === undefined || bValue === '';
    
    // Both are N/A - equal
    if (aIsNA && bIsNA) return 0;
    // Only a is N/A - should come after b
    if (aIsNA) return 1;
    // Only b is N/A - should come after a
    if (bIsNA) return -1;
    
    // Both have valid dates - compare as dates
    return new Date(bValue).getTime() - new Date(aValue).getTime();
  }
  
  // For string fields (ClientName, CameraName)
  if (typeof aValue === 'string' && typeof bValue === 'string') {
    return bValue.localeCompare(aValue);
  }
  
  // Default comparison for other types
  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;
  return 0;
};


const getFieldComparator = (order, orderBy) => {
  return order === 'desc'
    ? (a, b) => fieldDescendingComparator(a, b, orderBy)
    : (a, b) => -fieldDescendingComparator(a, b, orderBy);
};

const fieldDescendingComparator = (a, b, orderBy) => {
  let aValue = a[orderBy];
  let bValue = b[orderBy];
  
  // Handle datetime fields with N/A values
  if (orderBy === 'LastInactiveTime' || orderBy === 'LastActiveTime') {
    // Treat N/A as null (will sort to the end)
    if (aValue === 'N/A' || aValue === null) aValue = null;
    if (bValue === 'N/A' || bValue === null) bValue = null;
    
    if (aValue === null && bValue === null) return 0;
    if (aValue === null) return 1; // N/A comes after real dates
    if (bValue === null) return -1; // N/A comes after real dates
    
    return new Date(bValue) - new Date(aValue);
  }
  
  // Handle string fields
  // if (orderBy === 'ClientName' || orderBy === 'CameraName') {
  //   aValue = aValue || '';
  //   bValue = bValue || '';
  //   return bValue.localeCompare(aValue);
  // }

  // For CameraName field - integers first, then strings
  if (orderBy === 'CameraName') {
    // Handle null/undefined values
    if (aValue === null || aValue === undefined || aValue === '') aValue = '';
    if (bValue === null || bValue === undefined || bValue === '') bValue = '';
    
    // Check if values are numbers or strings
    const aIsNumber = !isNaN(aValue) && !isNaN(parseFloat(aValue));
    const bIsNumber = !isNaN(bValue) && !isNaN(parseFloat(bValue));
    
    // Both numbers - compare numerically
    if (aIsNumber && bIsNumber) {
      return parseFloat(bValue) - parseFloat(aValue);
    }
    // a is number, b is string - number comes first
    if (aIsNumber) return -1;
    // b is number, a is string - number comes first
    if (bIsNumber) return 1;
    // Both strings - compare alphabetically
    return bValue.localeCompare(aValue);
  }
  
  // For ClientName field - regular alphabetical sorting
  if (orderBy === 'ClientName') {
    // Handle null/undefined values
    if (aValue === null || aValue === undefined || aValue === '') aValue = '';
    if (bValue === null || bValue === undefined || bValue === '') bValue = '';
    
    return bValue.localeCompare(aValue);
  }
  
  // Default comparison
  if (bValue < aValue) return -1;
  if (bValue > aValue) return 1;
  return 0;
};

  const headCells = [
      { id: 'sno', label: 'S.No', disableSorting: true },
      { id: 'ClientName', label: 'Client Name' },
      { id: 'Location', label: 'Location' },
      { id: 'CameraName', label: 'Camera Name' },
      { id: 'LastInactiveTime', label: 'Camera Offline' },
      { id: 'LastActiveTime', label: 'Camera Online' },
      { id: 'history', label: 'History', disableSorting: true }
    ];

  


  return (
    <>
    <Box sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}`, p: 2 }}>
              <Grid container spacing={2}>             
                {/* <Grid item md={2} xs={4} >
                  <Box sx={{cursor: "pointer"}}>
                    <CountBoard color="primary" count={active} title="ActiceCameras" />    
                  </Box>                                    
                </Grid> */}
                <Grid item md={2} xs={4}>
                    <Box sx={{cursor: "pointer"}} onClick={handleOfflineCountClick}>
                      <CountBoard color="success" count={inactive} title="Cameras Offline"/>                         
                    </Box>                
                </Grid>
              </Grid>
    </Box>
      <Box sx={{ px: 2, pt: 2 }}>
          <Grid container spacing={2} alignItems="center" sx={{ mb: 2 }}>

          <Grid item xs={12} sm={compactLayout ? 2 : 3}>
            <Autocomplete
              fullWidth
              options={uniqueClientOptions}
              value={value3}
              getOptionLabel={(option) => `${option.displayname || ''}`}
              onChange={handleClientChange}
              open={openAutoClient}
              onOpen={() => setOpenAutoClient(true)}
              onClose={() => setOpenAutoClient(false)}
              isOptionEqualToValue={(option, value) => Number(option.ID) === Number(value?.ID)}
              renderOption={(props, option) => (
                <li {...props} key={option.ID}>
                  {option.displayname}
                </li>
              )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Client"
                  error={error && !value3}
                  helperText={error && !value3 ? "Please select a client" : ""}
                />
              )}
            />
          </Grid>

          {showLocationDropdown && (
            <Grid item xs={12} sm={compactLayout ? 2 : 3}>
              <Autocomplete
                multiple
                fullWidth
                options={locations}
                value={selectedLocationOptions}
                getOptionLabel={(option) =>
                  option.selectall ? option.title : `${option.Location || option.name || ''}`
                }
                onChange={handleLocationChange}
                disableCloseOnSelect
                open={openAutoLocation}
                onOpen={() => setOpenAutoLocation(true)}
                onClose={() => setOpenAutoLocation(false)}
                filterOptions={handleLocationFilterOptions}
                renderTags={() => null}
                renderOption={(props, option) => (
                  <li {...props} key={option.ID || option.id || option.title}>
                    {option.selectall ? (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selectAllLocation}
                        />
                        {option.title}
                      </>
                    ) : (
                      <>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selectedLocations.includes(option.ID || option.id)}
                        />
                        {option.Location || option.name || ''}
                      </>
                    )}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField {...params} placeholder="Select Locations" />
                )}
              />
            </Grid>
          )}

          {showGroupDropdown && (
            <Grid item xs={12} sm={compactLayout ? 2 : 3}>
              <Autocomplete
                value={value4}
                onChange={(_, newValue) => {
                  setValue4(newValue);
                  setSelectedCameras([]);
                  setSelectAllCam(false);
                }}
                options={groups}
                open={openAutoGroup}
                onOpen={() => setOpenAutoGroup(true)}
                onClose={() => setOpenAutoGroup(false)}
                isOptionEqualToValue={(option, value) => Number(option.Id) === Number(value?.Id)}
                getOptionLabel={(option) => option.GroupName || ''}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Group"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
          )}

          <Grid item xs={12} sm={compactLayout ? 2 : 3}>
                  <Autocomplete
                          multiple
                          fullWidth
                          id="clients-autocomplete"
                          options={cameras}
                          value={selectedCameras}
                          getOptionLabel={(option) => (option.selectAllCam && selectedCameras.length === cameras.length) ? 'Select All' : `${option.devicename || option.CameraName || ''}`}
                          onChange={handleCameraChange}
                          disableCloseOnSelect
                          open={openAutoCam}
                          onOpen={() => setOpenAutoCam(true)}
                          onClose={() => setOpenAutoCam(false)}
                          filterOptions={handleFilterOptionsCam}
                          renderTags={() => null}
                          renderOption={(props, option, { selected }) => (
                          <li {...props} key={option.deviceid || option.displayname}>
                                        {option.selectAllCam ? (
                                          <>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selectAllCam}
                                            />
                                            {option.displayname}
                                          </>
                                        ) : (
                                          <>
                                            <Checkbox
                                              icon={icon}
                                              checkedIcon={checkedIcon}
                                              style={{ marginRight: 8 }}
                                              checked={selectedCameras.some(device => device.deviceid === option.deviceid)}
                                            />
                                            {`${option.devicename}`}
                                          </>
                                        )}
                                      </li>
                          )}
                          renderInput={(params) => (
                          <TextField
                          {...params}
                          placeholder="Select Cameras"
                          error={error && selectedCameras.length === 0}
                          helperText={error && selectedCameras.length === 0 ? "Please select at least one camera" : ""}
                          onFocus={() => setOpenAutoCam(true)} />
                          )}
                    />
          </Grid>
              
          <Grid item xs={12} sm={compactLayout ? 2 : 3}>
            {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                label="Select Date"
                value={selectedDate}
                onChange={(newDate) => {
                  setSelectedDate(newDate);
                  setIsDateSelected(false);
                  setError(false)
                }}
                slotProps={{
                  textField: {
                    error: error && isDateSelected,
                    helperText: (error && isDateSelected) ? "please select a date" : "",
                  },
                }}
                />
            </LocalizationProvider> */}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            shouldDisableDate={shouldDisableDate}
            slotProps={{
              textField: {
                placeholder: "Select Date",
                error: error && isDateSelected,
                helperText: (error && isDateSelected) ? "Please select a date" : '',
              },
              desktopPaper: {
                sx: {
                  '& .Mui-selected': {
                    backgroundColor: `${theme.palette.primary.main} !important`,
                    color: `${theme.palette.primary.contrastText} !important`,
                  },
                  '& .Mui-disabled': {
                    opacity: 0.3,
                  },
                },
              },
            }}
            views={['year', 'month', 'day']}
          />
        </LocalizationProvider>

          </Grid>

          <Grid item xs={12} sm={compactLayout ? 2 : 1}>
                      <Button variant="contained" onClick={handleButtonClick}>
                        Generate
                      </Button>
          </Grid>



          
          </Grid>

          {loading && (
        <Grid container justifyContent="center" sx={{ my: 4 }}>
          <CircularProgress size={60} />
        </Grid>
      )}

      {noData && !loading && (
        <Grid container justifyContent="center" sx={{ my: 4 }}>
          <Typography>
            No data 
          </Typography>
        </Grid>
      )}

      {!loading && response.length > 0 && (
        <TableContainer sx={{ minWidth: 650 }}>
            <Table aria-label="camera status table">
              <TableHead sx={{ '& th': { bgcolor: 'background.neutral', fontWeight: 600 } }}>
              <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      sortDirection={orderBy === headCell.id ? order : false}
                    >
                      {headCell.disableSorting ? headCell.label : (
                        <TableSortLabel
                          active={orderBy === headCell.id}
                          direction={orderBy === headCell.id ? order : 'asc'}
                          onClick={() => handleRequestSort(headCell.id)}
                        >
                          {headCell.label}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {/* <TableBody>
                {response.map((row, index) => (
                  <TableRow key={row.CameraId}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.ClientName}</TableCell>
                    <TableCell>{row.CameraName}</TableCell>
                    <TableCell>
                      {row.LastInactiveTime ? 
                        dayjs(row.LastInactiveTime).format('YYYY-MM-DD HH:mm:ss') : 
                        'N/A'}
                    </TableCell>
                    <TableCell>
                      {row.LastActiveTime ? 
                        dayjs(row.LastActiveTime).format('YYYY-MM-DD HH:mm:ss') : 
                        'N/A'}
                    </TableCell>
                    <TableCell>
                      <Tooltip title="View history">
                        <IconButton onClick={() => handleHistoryClick(row.CameraId,row.CameraName)}> 
                          <HistoryIcon color="primary" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody> */}
              <TableBody>
                {stableSort(response, getComparator(order, orderBy))
                  .map((row, index) => (
                    <TableRow key={row.CameraId}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{row.ClientName}</TableCell>
                      <TableCell>
                        {formatLocations(row.Location).length > 0
                          ? formatLocations(row.Location).map((location, locationIndex) => (
                              <Box
                                key={`${row.CameraId}-${location}-${locationIndex}`}
                                sx={{
                                  borderBottom:
                                    locationIndex !== formatLocations(row.Location).length - 1
                                      ? '1px solid #ddd'
                                      : 'none',
                                  py: 0.5,
                                }}
                              >
                                {location}
                              </Box>
                            ))
                          : ''}
                      </TableCell>
                      <TableCell>{row.CameraName}</TableCell>
                      <TableCell>
                        {row.LastInactiveTime ? 
                          dayjs(row.LastInactiveTime).format('YYYY-MM-DD HH:mm:ss') : 
                          'N/A'}
                      </TableCell>
                      <TableCell>
                        {row.LastActiveTime ? 
                          dayjs(row.LastActiveTime).format('YYYY-MM-DD HH:mm:ss') : 
                          'N/A'}
                      </TableCell>
                      <TableCell>
                        <Tooltip title="View history">
                          <IconButton
                            onClick={() => handleHistoryClick(row.CameraId,row.CameraName)}
                            sx={{
                              backgroundColor: 'primary.main',
                              '&:hover': { backgroundColor: 'primary.dark' },
                            }}
                          >
                            <HistoryIcon sx={{ color: (theme) => theme.palette.primary.contrastText }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
      )}


      </Box>

      {/* <Dialog open={historyOpen} onClose={handleHistoryClose} maxWidth="xs" fullWidth>
        <DialogTitle>{historyCameraName || "Camera History"}</DialogTitle>
        <DialogContent dividers>
          {historyLoading ? (
            <Grid container justifyContent="center" sx={{ my: 3 }}>
              <CircularProgress />
            </Grid>
          ) : mergedTimeline.length > 0 ? (
            <Timeline 
              position="right"
              sx={{
          "& .MuiTimelineItem-root": {
            minHeight: "40px",
            "&:before": {
              flex: 0, // This removes the extra space on the left
              padding: 0,
            }
          },
          "& .MuiTimelineContent-root": {
            paddingLeft: "16px",
            marginTop: "0px",
            textAlign: "left",
          },
          "& .MuiTimelineSeparator-root": {
            flex: "0 0 auto",
          },
          "& .MuiTimelineDot-root": {
            marginLeft: "0px",
           // marginRight: "12px",
          },
          // Center the entire timeline
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 0,
        }}
            >
              {mergedTimeline.slice().reverse().map((item, index) => (
                <TimelineItem key={index}>
                  <TimelineSeparator>
                    <TimelineDot color={item.status === "active" ? "success" : "error"} />
                    {index !== mergedTimeline.length - 1 && <TimelineConnector />}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography variant="body1" sx={{ fontWeight: 600 }}>
                      {item.status === "active" ? "Camera Online" : "Camera Offline"}
                    </Typography>
                    <Typography variant="body2">
                      {dayjs(item.time).format("DD MMM YYYY, HH:mm:ss A")}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {item.client_name} - {item.camera_name}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          ) : (
            <Typography>No history available</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleHistoryClose}>Close</Button>
        </DialogActions>
      </Dialog> */}

      <Drawer
        anchor="right"
        open={historyOpen}
        onClose={handleHistoryClose}
        sx={{
          '& .MuiDrawer-paper': {
            width: 320,
            maxWidth: '85vw',
            padding: '0', // Remove padding from drawer to handle it internally
            display: 'flex',
            flexDirection: 'column',
          },
        }}
>
        {/* Fixed Header Section */}
        <Box sx={{ 
          padding: '12px',
          borderBottom: '1px solid',
          borderColor: 'divider',
          flexShrink: 0, // Prevent header from shrinking
          backgroundColor: 'background.paper',
          zIndex: 1, // Ensure header stays above content
        }}>
          <Box sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
          }}>
            <Typography variant="h6" sx={{ fontSize: '1.1rem' }}>
              {historyCameraName || "Camera History"}
            </Typography>
            <IconButton onClick={handleHistoryClose} size="small">
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
  
        {/* Scrollable Content Section */}
        <Box sx={{ 
          flexGrow: 1, // Take up all available space
          overflow: 'auto', // Enable scrolling
          padding: '12px',
        }}>
          {historyLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 3 }}>
              <CircularProgress size={24} />
            </Box>
          ) : mergedTimeline.length > 0 ? (
            <Timeline 
              position="right"
              sx={{
                padding: 0,
                margin: 0,
                "& .MuiTimelineItem-root": {
                  minHeight: "32px",
                  "&:before": {
                    flex: 0,
                    padding: 0,
                  }
                },
                "& .MuiTimelineContent-root": {
                  padding: '2px 6px 2px 6px',
                  textAlign: "left",
                },
                "& .MuiTimelineSeparator-root": {
                  flex: "0 0 auto",
                },
                "& .MuiTimelineDot-root": {
                  margin: '4px 0',
                  width: '8px',
                  height: '8px',
                },
                "& .MuiTimelineConnector-root": {
                  margin: '0 auto',
                },
              }}
            >
              {mergedTimeline.slice().reverse().map((item, index) => (
                <TimelineItem key={index}>
                  <TimelineSeparator>
                    <TimelineDot color={item.status === "active" ? "success" : "error"} />
                    {index !== mergedTimeline.length - 1 && <TimelineConnector />}
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography variant="body2" sx={{ 
                      fontWeight: 600, 
                      fontSize: '0.8rem'
                    }}>
                      {item.status === "active" ? "Camera Online" : "Camera Offline"}
                    </Typography>
                    <Typography variant="body2" sx={{ fontSize: '0.75rem' }}>
                      {dayjs(item.time).format("DD MMM, HH:mm:ss")}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ 
                      fontSize: '0.7rem',
                      display: 'block',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      maxWidth: '180px'
                    }}>
                      {item.client_name} - {item.camera_name}
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              ))}
            </Timeline>
          ) : (
            <Typography variant="body2" sx={{ 
              textAlign: 'center', 
              my: 2,
              fontSize: '0.9rem'
            }}>
              No history available
            </Typography>
          )}
        </Box>
      </Drawer>
      {/* <Drawer
        anchor="right"
        open={historyOpen}
        onClose={handleHistoryClose}
        sx={{
          '& .MuiDrawer-paper': {
            width: 320,
            maxWidth: '85vw',
            padding: '12px',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">
            {historyCameraName || "Camera History"}
          </Typography>
          <IconButton onClick={handleHistoryClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        
        <Divider sx={{ mb: 2 }} />
        
        {historyLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
            <CircularProgress />
          </Box>
        ) : mergedTimeline.length > 0 ? (
          <Timeline 
            position="right"
            sx={{
              padding: 0,
              margin: 0,
              "& .MuiTimelineItem-root": {
                minHeight: "36px",
                "&:before": {
                  flex: 0,
                  padding: 0,
                }
              },
              "& .MuiTimelineContent-root": {
                padding: '4px 8px 4px 8px',
                textAlign: "left",
              },
              "& .MuiTimelineSeparator-root": {
                flex: "0 0 auto",
              },
              "& .MuiTimelineDot-root": {
                margin: '6px 0',
                width: '10px',
                height: '10px',
              },
              "& .MuiTimelineConnector-root": {
                margin: '0 auto',
              },
            }}
          >
            {mergedTimeline.slice().reverse().map((item, index) => (
              <TimelineItem key={index}>
                <TimelineSeparator>
                  <TimelineDot color={item.status === "active" ? "success" : "error"} />
                  {index !== mergedTimeline.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.85rem' }}>
                    {item.status === "active" ? "Camera Online" : "Camera Offline"}
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '0.8rem' }}>
                    {dayjs(item.time).format("DD MMM YYYY, HH:mm:ss")}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
                    {item.client_name} - {item.camera_name}
                  </Typography>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        ) : (
          <Typography variant="body2" sx={{ textAlign: 'center', my: 2 }}>
            No history available
          </Typography>
        )}
      </Drawer> */}

       <Dialog 
        open={offlineDialogOpen} 
        onClose={() => setOfflineDialogOpen(false)} 
        maxWidth="lg" 
        fullWidth
      >
        <DialogTitle>Offline Cameras Details</DialogTitle>
        <DialogContent dividers>
          <TableContainer>
            <Table>
              <TableHead sx={{ '& th': { bgcolor: 'background.neutral', fontWeight: 600 } }}>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>Client Name</TableCell>
                  <TableCell>Camera Name</TableCell>
                  <TableCell>Camera ID</TableCell>
                  <TableCell>Last Offline Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {offlineCameras.map((camera, index) => (
                  <TableRow key={camera.CameraId}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{camera.displayname}</TableCell>
                    <TableCell>{camera.devicename}</TableCell>
                    <TableCell>{camera.deviceid}</TableCell>
                    <TableCell>
                      {camera.LastInactiveTime ? 
                        dayjs(camera.LastInactiveTime).format('YYYY-MM-DD HH:mm:ss') : 
                        'N/A'}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOfflineDialogOpen(false)} variant="outlined" color="error">Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CameraActiveReport;
